/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label } from "reactstrap";
import { ToggleLeft } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { BlurSpinner } from "../../components/BlurSpinner";
import { StyledSelect } from "../../components/StyledSelect";
import SpinnerButton from "../../components/Button";
import { fetchRegiones } from "../../services/regionServices";
import useFetcher from "../../hooks/useFetcher";
import { fetchSucursales } from "../../services/sucursalServices";
import { createSubclient, patchSubclient, fetchSubclientsPaginados } from "../../services/subclientesServices";
import { fetchCompanias } from "../../services/companiaServices";
import { fetchServicios } from "../../services/servicioServices";
import { handleErrors } from "../../services/handleErrors";
import ConfirmModal from "./Tabs/ConfirmModal";
import ConfirmInactiveSubclient from "./Tabs/ConfirmInactiveSubclient";
import usePaging from "../../hooks/usePaging";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import { fetchCasasCentrales } from "../../services/casaCentralServices";
import compareDataChanges from "../../utils/compareDataChanges";
import "./styles.scss";
import { useAuth } from "../../context/AuthContext";
// import { subclienteUtil } from "../../utils/subclienteUtil";
import modulos from "../../mocks/modulos";

function SubclientInfo({ toggle, subclientData = null, razonSocial, ClientId = null, history, subclienteUtil }) {
  const { currentUser } = useAuth();
  const isAdmin = false; // currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.CLIENTES);

  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [regionSelected, setRegionSelected] = useState(null);
  const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");
  const isOwner = useMemo(() => subclienteUtil.isOwner(currentUser.user), [subclienteUtil, currentUser.user]);
  const canDesactivateSubclient = currentUser && (currentUser.haveAdminAccess(modulos.CLIENTES) || isOwner) && !isAudit;
  const [sucursalSelected, setSucursalSelected] = useState(null);
  const [servicioSelected, setServicioSelected] = useState(null);
  const [companiaSelected, setCompaniaSelected] = useState(null);
  const [ClientIdSelected, setClientIdSelected] = useState(null);
  const [numeroDeLegajo, setNumeroDeLegajoSelected] = useState(null);
  const [isLoadingInfo, setIsLoadingInfo] = useState(false);
  const [confirmarModal, setConfirmarModal] = useState(false);
  const [confirmModalInactive, setConfirmarModalInactive] = useState(false);
  const [changes, setChanges] = useState({
    region2: false,
    servicio2: false,
    compania: false,
    numeroDeLegajo: false,
    sucursalId: false,
  });
  const pagingController = usePaging(fetchSubclientsPaginados);

  const helperRegionSucursal = retriveRegionSucursalOptions(
    regionSelected,
    sucursalSelected,
    regiones,
    sucursales,
    casasCentrales,
    isLoadingRegiones || isLoadingSucursales || isLoadingCasasCentrales
  );

  const formik = useFormik({
    initialValues: {
      razonSocial,
      ClientId,
      region2: (subclientData && subclientData.Sucursal && subclientData.Sucursal.region2) || null,
      sucursalId: (subclientData && subclientData.Sucursal && subclientData.Sucursal.itemId) || null,
      servicio2: (subclientData && subclientData.servicio2) || null,
      compania: (subclientData && subclientData.compania) || null,
      numeroDeLegajo: (subclientData && subclientData.numeroDeLegajo.replace(".0000", "")) || "",
    },
    onSubmit: async (info) => {
      const filteredInfo = compareDataChanges(info, subclientData);
      setIsLoadingInfo(true);
      try {
        if (subclientData) {
          await patchSubclient(subclientData.itemId, filteredInfo);
          toast.success("Subcliente actualizado");
        } else {
          await createSubclient(filteredInfo);
          toast.success("Subcliente creado");
        }
        setIsLoadingInfo(false);
        setConfirmarModal(false);
        toggle();
      } catch (error) {
        handleErrors(error);
        setIsLoadingInfo(false);
        setConfirmarModal(false);
        toast.error("El subcliente no se pudo crear.");
      }
    },
    validationSchema: Yup.object().shape({
      region2: subclientData
        ? Yup.number().notRequired().nullable()
        : Yup.number().typeError("Debe seleccionar una región de la lista").required("Este campo es requerido."),
      sucursalId: subclientData
        ? Yup.number().notRequired().nullable()
        : Yup.number().typeError("Debe seleccionar una sucursal de la lista").required("Este campo es requerido."),
      servicio2: subclientData ? Yup.number().nullable() : Yup.number().typeError("Debe seleccionar un servicio de la lista").required("Este campo es requerido."),
      compania: subclientData
        ? Yup.number().notRequired().nullable()
        : Yup.number().typeError("Debe seleccionar una compañia de la lista").required("Este campo es requerido."),
      numeroDeLegajo: subclientData
        ? Yup.string().notRequired().nullable()
        : Yup.number().typeError("Debe ingresar el numero de subcliente").required("Este campo es requerido."),
    }),
  });

  const handleReactSelectChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null };
    pagingController.setFilterValue(newState);
  };
  const inactivateSubclient = async () => {
    setIsLoadingInfo(true);
    await patchSubclient(subclientData.itemId, { estado: 2 });
    toast.success("Subcliente actualizado");
    setIsLoadingInfo(false);
    setConfirmarModalInactive(false);
    toggle();
  };
  const regionOptions = regiones.map((region) => {
    return { label: region.title, value: region.itemId };
  });

  const handleRegionChange = (selected) => {
    setRegionSelected(selected);
  };

  const sucursalOptions = sucursales.map((sucursal) => {
    return { label: sucursal.titulo, value: sucursal.itemId };
  });

  const handleSucursalChange = (selected) => {
    setSucursalSelected(selected);
  };

  const serviciosOptions = servicios.map((servicio) => {
    return { label: servicio.text, value: servicio.id };
  });
  const handleServicioChange = (selected) => {
    setServicioSelected(selected);
  };

  const companiasOptions = companias.map((compania) => {
    return { label: compania.text, value: compania.id };
  });
  const handleCompaniaChange = (selected) => {
    setCompaniaSelected(selected);
  };

  const handleBlur = (value) => {
    if (subclientData) {
      if (formik.values[value] == null) {
        setChanges((prevState) => ({ ...prevState, [value]: true }));
        return;
      }
      if (formik.values[value] !== subclientData[value]) {
        setChanges((prevState) => ({ ...prevState, [value]: true }));
        return;
      }
      if (formik.values[value] === subclientData[value]) {
        setChanges((prevState) => ({ ...prevState, [value]: false }));
        return;
      }
    }
    if (formik.values[value] != null || formik.values[value] !== "") {
      setChanges((prevState) => ({ ...prevState, [value]: true }));
    } else {
      setChanges((prevState) => ({ ...prevState, [value]: false }));
    }
  };

  const zeroPad = (num, places) => String(num).padStart(places, "0");

  return (
    <>
      {confirmModalInactive && (
        <ConfirmInactiveSubclient isLoading={isLoadingInfo} toggle={() => setConfirmarModalInactive(!confirmModalInactive)} handleSubmit={inactivateSubclient} />
      )}
      {confirmarModal && <ConfirmModal isLoading={isLoadingInfo} toggle={() => setConfirmarModal(!confirmarModal)} handleSubmit={formik.handleSubmit} />}
      <Modal centered isOpen toggle={toggle}>
        <ModalHeader toggle={toggle}>{subclientData ? "Info Subcliente" : "Nuevo Subcliente"}</ModalHeader>
        <ModalBody>
          <FormGroup className="d-flex justify-content-between w-100">
            <div className="col-form-group p-0 w-100" style={{ margin: 0, position: "relative" }}>
              <Label htmlFor="numeroDeLegajo" className="col-form-label p-0 w-100">
                Numero de Subcliente
              </Label>
              <input
                className={formik.errors.fechaDeEntrega && formik.touched.fechaDeEntrega ? "form-control error-field w-100 " : "form-control w-100 "}
                type="number"
                name="numeroDeLegajo"
                onChange={formik.handleChange}
                onBlur={() => handleBlur("numeroDeLegajo")}
                value={zeroPad(formik.values.numeroDeLegajo, 7)}
                onKeyUp={(e) => (e.currentTarget.value = e.currentTarget.value.slice(0, 7))}
                disabled={subclientData}
                onWheel={(e) => e.target.blur()}
              />
              {changes.numeroDeLegajo ? <div className="input-feedback">Cambios por guardar.</div> : null}
              {formik.errors.numeroDeLegajo && formik.touched.numeroDeLegajo && <div className="input-feedback">{formik.errors.numeroDeLegajo}</div>}
            </div>
          </FormGroup>
          <FormGroup className="d-flex justify-content-between w-100">
            <Label htmlFor="region2" className="col-form-label pt-0 w-100">
              Región
              <StyledSelect
                id="region2"
                name="region2"
                className="w-100"
                formik={formik}
                onChange={handleRegionChange}
                value={regionOptions.find((option) => {
                  return option.value === formik.values.region2;
                })}
                placeholder="Todo"
                isClearable
                onBlur={() => handleBlur("region2")}
                isLoading={isLoadingRegiones}
                options={regionOptions}
                isDisabled={!isAdmin}
              />
              {changes.region2 ? <div className="input-feedback">Cambios por guardar.</div> : null}
              {formik.errors.region2 && formik.touched.region2 && <div className="input-feedback">{formik.errors.region2}</div>}
            </Label>
          </FormGroup>
          <FormGroup className="d-flex justify-content-between w-100">
            <Label htmlFor="sucursalId" className="col-form-label pt-0 w-100">
              Sucursal
              <StyledSelect
                id="sucursalId"
                name="sucursalId"
                className="w-100"
                formik={formik}
                enableReinitialize
                onChange={handleSucursalChange}
                value={sucursalOptions.find((option) => {
                  return option.value === formik.values.sucursalId;
                })}
                placeholder="Todo"
                isClearable
                onBlur={() => handleBlur("sucursalId")}
                isLoading={isLoadingSucursales}
                options={sucursalOptions}
                isDisabled={!isAdmin}
              />
              {formik.errors.sucursalId && formik.touched.sucursalId && <div className="input-feedback">{formik.errors.sucursalId}</div>}
            </Label>
          </FormGroup>
          <FormGroup className="d-flex justify-content-between w-100">
            <Label htmlFor="servicio2" className="col-form-label pt-0 w-100">
              Servicio
              <StyledSelect
                id="servicio2"
                name="servicio2"
                className="w-100"
                formik={formik}
                onChange={handleServicioChange}
                value={serviciosOptions.find((option) => {
                  return option.value === formik.values.servicio2;
                })}
                placeholder="Todo"
                isClearable
                onBlur={() => handleBlur("servicio2")}
                isLoading={isLoadingServicios}
                options={serviciosOptions}
                isDisabled={!isAdmin}
              />
              {changes.servicio2 ? <div className="input-feedback">Cambios por guardar.</div> : null}
              {formik.errors.servicio2 && formik.touched.servicio2 && <div className="input-feedback">{formik.errors.servicio2}</div>}
            </Label>
          </FormGroup>
          <FormGroup className="d-flex justify-content-between w-100">
            <Label htmlFor="compania" className="col-form-label pt-0 w-100">
              Compañia
              <StyledSelect
                id="compania"
                name="compania"
                className="w-100"
                formik={formik}
                onChange={handleCompaniaChange}
                value={companiasOptions.find((option) => {
                  return option.value === formik.values.compania;
                })}
                placeholder="Todo"
                isClearable
                onBlur={() => handleBlur("compania")}
                isLoading={isLoadingCompanias}
                options={companiasOptions}
                isDisabled={!isAdmin}
              />
              {changes.compania ? <div className="input-feedback">Cambios por guardar.</div> : null}
              {formik.errors.compania && formik.touched.compania && <div className="input-feedback">{formik.errors.compania}</div>}
            </Label>
          </FormGroup>
          {subclientData && subclientData.servicio2Cat && (
            <FormGroup className="d-flex justify-content-between w-100">
              <Label htmlFor="estado" className="col-form-label  w-100">
                Estado:&nbsp;&nbsp;
                {subclientData.servicio2Cat.status === "active" ? (
                  <span className="text-success badge" style={{ fontSize: "14px" }}>
                    Activo
                  </span>
                ) : (
                  <span className="text-danger">Inactivo</span>
                )}
              </Label>
              {canDesactivateSubclient && (
                <FontAwesomeIcon
                  icon={faToggleOn}
                  style={{ color: "#02d406", fontSize: "30px", cursor: "pointer" }}
                  onClick={() => setConfirmarModalInactive(!confirmModalInactive)}
                />
              )}
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <FormGroup className="mb-0 px-3">
            {isAdmin && !isAudit && (
              <SpinnerButton className="btn btn-primary btn-block" onClick={() => setConfirmarModal(!confirmarModal)}>
                {subclientData ? "Guardar Cambios" : "Crear Subcliente"}
              </SpinnerButton>
            )}
          </FormGroup>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default SubclientInfo;
